import type { GridSelection, Item } from "@artis/data-grid";

import { cellKey } from "@package/scratchpad-utils";

/** A1 or A1:C3 for the current range. Empty when nothing is selected. */
export function selectionRangeLabel(selection: GridSelection | undefined): string {
  const range = selection?.current?.range;
  if (!range) return "";
  const start = cellKey(range.x, range.y);
  if (range.width === 1 && range.height === 1) return start;
  return `${start}:${cellKey(range.x + range.width - 1, range.y + range.height - 1)}`;
}

/** The cells covered by a grid selection: the current range plus any stacked ranges, deduplicated. */
export function selectionItems(selection: GridSelection | undefined): Item[] {
  const current = selection?.current;
  if (!current) return [];
  const seen = new Set<string>();
  const items: Item[] = [];
  for (const rect of [current.range, ...current.rangeStack]) {
    for (let r = 0; r < rect.height; r++) {
      for (let c = 0; c < rect.width; c++) {
        const key = cellKey(rect.x + c, rect.y + r);
        if (!seen.has(key)) {
          seen.add(key);
          items.push([rect.x + c, rect.y + r]);
        }
      }
    }
  }
  return items;
}

/** The cell keys covered by a grid selection, in the same order as {@link selectionItems}. */
export function selectionCellKeys(selection: GridSelection | undefined): string[] {
  return selectionItems(selection).map((item) => cellKey(item[0], item[1]));
}
